import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { CourseService } from 'src/app/services/course/course.service';
import { AddExamComponent } from '../add-exam/add-exam.component';
import { AddCourseComponent } from '../add-course/add-course.component';
import { DeleteItemComponent } from '../../delete-item/delete-item.component';
import { CookieService } from 'ngx-cookie-service';
import { AppService } from 'src/app/services/app/app.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { Filter } from '../../filter/filter.model';
import { PaginationInstance } from 'ngx-pagination';
import { CommonService } from 'src/app/services/common/common.service';
import { AlertComponent } from '../../alert/alert.component';
import { ViewCoursePreviewComponent } from '../view-course-preview/view-course-preview.component';
import { AgreeTermsConditionComponent } from '../../package-management/agree-terms-condition/agree-terms-condition.component';

@Component({
  selector: 'app-course-builder',
  templateUrl: './course-builder.component.html',
  styleUrls: ['./course-builder.component.scss','../../../../assets/scss/common/_course-box.scss']
})
export class CourseBuilderComponent {
  public pageSizeOptions = GlobalService.pageSizeOptions;
  public count!: any;
  public courseArr: any[] = [
  ]
  public isSpinnerLoading: boolean = false;
  private animationConfig: {} = { enterAnimationDuration: '300ms', exitAnimationDuration: "300ms", }
  public imageUrl = GlobalService.imageURL;
  public filteredItems: any[] = []
  public isAdmin: boolean = false;
  public isFilterShow: boolean = false;
  public filterObj: Filter = {
    operand: "and",
    arr: []
  }
  public filterArr: any[] = [
    { key_name: "Title", key_val: "tit", type: 'text' },
    { key_name: "Description", key_val: "desc", type: 'text' },
  ]
  public maxPaginationSize = GlobalService.maxPaginationSize
  public config: PaginationInstance = {
    itemsPerPage: this.pageSizeOptions[0],
    currentPage: 0,
  };
  public searchInput: string = '';
  private previousInputValue: string = '';
  public userType:any;
  constructor(private courseService: CourseService, private spinner: NgxSpinnerService, private router: Router, public dialog: MatDialog,
    private cookieService: CookieService, private appService: AppService, private commonService: CommonService) { }

  ngOnInit(): void {

    this.commonService.setTitle("Course Builder")
    // this.checkUserType();

  }
}
